"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _ListSelector = _interopRequireDefault(require("../../preact-components/list-selector/ListSelector"));

var _UserList = _interopRequireDefault(require("../../preact-components/list-selector/UserList"));

var _UserAvatar = _interopRequireDefault(require("../../preact-components/User/UserAvatar"));

var AuthorSelector = function AuthorSelector(_ref) {
  var selected = _ref.selected,
      onChange = _ref.onChange;

  var DropdownText = function DropdownText() {
    return selected ? (0, _preact.h)("span", {
      className: "selected"
    }, (0, _preact.h)("div", null, (0, _preact.h)(_UserAvatar.default, {
      disableLink: true,
      disablePopup: true,
      user: {
        id: selected.id,
        name: selected.username,
        avatar: selected.avatar
      }
    })), (0, _preact.h)("div", {
      className: "truncated"
    }, selected.username)) : (0, _preact.h)("span", null, "Choose an Author");
  };

  var className = (0, _classnames.default)('author-selector qa-author-selector', !selected && 'no-author-selected-message');
  return (0, _preact.h)("div", {
    className: "author-selector-wrapper"
  }, (0, _preact.h)(_DropdownControl.default, {
    align: "adjust",
    trigger: (0, _preact.h)(_Button.default, {
      title: (0, _preact.h)(DropdownText, null),
      className: className,
      endIcon: "chevronDown",
      size: "medium"
    }),
    items: [],
    hasSearch: true,
    closeOnDropdownClick: true,
    onTriggerClicked: function onTriggerClicked(_ref2) {
      var close = _ref2.close;
      return (0, _preact.h)(_ListSelector.default, {
        align: "left",
        isDynamic: true,
        hasSearch: true,
        fetchUrl: "/member/getAuthors?filterByRole=1&query=",
        placeholder: "Search by username"
      }, function (users) {
        return (0, _preact.h)("div", null, (0, _preact.h)(_UserList.default, {
          users: users,
          onClick: function onClick(user) {
            var _user$avatar;

            onChange({
              id: user.id.toString(),
              username: user.name,
              avatar: (_user$avatar = user.avatar) !== null && _user$avatar !== void 0 ? _user$avatar : ''
            });
            close();
          }
        }));
      });
    }
  }));
};

var _default = AuthorSelector;
exports.default = _default;